import { siteStats } from "@/mocks/site";

export default function StatsSection() {
  return (
    <section id="numbers" className="w-full bg-foreground-950 py-14 md:py-20 scroll-mt-[72px]">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.3em] uppercase text-accent-400 mb-3">
              <span className="block w-6 h-px bg-accent-500"></span>
              Data Overview
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
              用可核验的资料，替代情绪判断
            </h2>
          </div>
          <p className="text-sm text-foreground-300 max-w-md leading-relaxed">
            以下数据来自本站已公开的调查档案与样本归纳，用于说明问题规模，不代表任何个案结论。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {siteStats.map((stat, index) => (
            <div
              key={stat.label}
              className={`p-5 md:p-6 rounded-lg border ${
                index === 0
                  ? "bg-primary-950 border-primary-800"
                  : "bg-foreground-900 border-foreground-800"
              }`}
            >
              <div className="flex items-baseline gap-1">
                <span
                  className={`font-heading text-3xl md:text-4xl font-black ${
                    index === 0 ? "text-accent-400" : "text-background-50"
                  }`}
                >
                  {stat.value}
                </span>
                <span className="text-sm text-foreground-400">{stat.unit}</span>
              </div>
              <h3 className="mt-3 font-heading text-base font-semibold text-background-100">
                {stat.label}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-400">{stat.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}